(function () {
  'use strict';

  function ensureCompareBootstrapProxy() {
    if (document.querySelector('[data-itmart-compare-bootstrap-proxy="true"]')) {
      return;
    }

    const proxy = document.createElement('xb-button-comparison');
    proxy.setAttribute('data-itmart-compare-bootstrap-proxy', 'true');
    proxy.setAttribute('hidden', 'hidden');
    proxy.setAttribute('aria-hidden', 'true');
    proxy.style.display = 'none';
    document.body.appendChild(proxy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureCompareBootstrapProxy, { once: true });
  }

  ensureCompareBootstrapProxy();
})();